<template>
  <svg width="27px" height="26px" viewBox="0 0 27 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>BA862FDC-5BC9-4607-A650-2863DCD788B2OVER</title>
    <g id="Page-Layouts" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Profile-Mobile" transform="translate(-75.000000, -578.000000)">
        <g id="Intro-Block" transform="translate(20.000000, 248.000000)">
          <g id="Social-Links-GRAYED-OUT" transform="translate(20.000000, 330.000000)">
            <g id="f" transform="translate(35.100000, 0.000000)">
              <circle id="Oval" fill="#000000" cx="13" cy="13" r="13"></circle>
              <path d="M16.2786646,13.0046136 L14.0928602,13.0046136 C14.0928602,16.4975946 14.0928602,20.8 14.0928602,20.8 L10.8531125,20.8 C10.8531125,20.8 10.8531125,16.5416798 10.8531125,13.0046136 L9.31218193,13.0046136 L9.31218193,10.2523659 L10.8531125,10.2523659 L10.8531125,8.46896688 C10.8531125,7.19254732 11.4590274,5.2 14.1231046,5.2 L16.5221583,5.20922713 L16.5221583,7.88253155 C16.5221583,7.88253155 15.0632466,7.88253155 14.7802813,7.88253155 C14.4957781,7.88253155 14.0933728,8.02452681 14.0933728,8.63146688 L14.0933728,10.2528785 L16.5631677,10.2528785 L16.2786646,13.0046136 Z" id="Path-Copy" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "FacebookBlack"
}
</script>

<style scoped>

</style>